export const tickerItems = [
  '新料 #4820 · 综艺剪辑争议话题阅读破百万',
  '热榜 TOP1 · 周末档新剧口碑两极化讨论升温',
  '话题墙 10 分钟新增 36 条讨论帖',
  '黑料福利今日已更新 128 条内容',
  '网友整理争议时间线，评论区已经吵翻',
  '社区投票 · 本周最想追的话题结果出炉',
  '晚间更新 · 夜宵档最新新料预告上线',
  '黑料福利每日推荐 · 今日热搜话题 5 条',
];

export const heroStats = [
  { label: '今日更新', value: '128', unit: '条' },
  { label: '在线讨论', value: '876', unit: '人' },
  { label: '讨论话题', value: '3621', unit: '个' },
];

export const featuredPosts = [
  {
    tag: '影视综艺',
    title: '某综艺剪辑争议冲上热榜，网友整理出三个版本的时间线',
    excerpt: '同一段素材被剪出两种叙事走向，讨论区从中午一直聊到深夜，话题墙相关帖已破千。',
    comments: '1.2万',
    heat: '98.6万',
    time: '12 分钟前',
    seq: 'hl-feature-01',
    image: 'https://readdy.ai/api/search-image?query=abstract%20stacked%20retro%20television%20screens%20glowing%20in%20a%20dark%20studio%2C%20warm%20crimson%20and%20amber%20color%20grading%2C%20dramatic%20cinematic%20rim%20light%2C%20soft%20blurred%20background%2C%20stylized%20editorial%20magazine%20cover%2C%20no%20people%2C%20high%20detail%2C%20subtle%20grain%20texture&width=900&height=600&seq=hl-feature-01&orientation=landscape',
  },
  {
    tag: '网红电商',
    title: '带货直播数据遭质疑，观众自发复盘当晚成交曲线',
    excerpt: '有人把整场直播的时间戳做成表格，热度曲线在某两分钟出现异常尖峰，讨论持续发酵。',
    comments: '8634',
    heat: '76.2万',
    time: '48 分钟前',
    seq: 'hl-feature-02',
    image: 'https://readdy.ai/api/search-image?query=abstract%20smartphone%20screen%20glow%20among%20scattered%20cinema%20tickets%20and%20receipts%20on%20a%20dark%20reflective%20desk%2C%20warm%20crimson%20and%20amber%20color%20grading%2C%20dramatic%20cinematic%20lighting%2C%20soft%20blurred%20background%2C%20editorial%20magazine%20texture%2C%20no%20people%2C%20high%20detail&width=900&height=600&seq=hl-feature-02&orientation=landscape',
  },
  {
    tag: '电竞主播',
    title: '直播间突发状况被全程录屏，粉丝分成两派各执一词',
    excerpt: '一段不到两分钟的录屏在社区里被反复分析，双方各自整理证据，话题墙已开专场讨论。',
    comments: '6218',
    heat: '63.4万',
    time: '2 小时前',
    seq: 'hl-feature-03',
    image: 'https://readdy.ai/api/search-image?query=abstract%20gaming%20controller%20and%20headset%20under%20moody%20warm%20amber%20light%20on%20a%20dark%20studio%20table%2C%20crimson%20accent%20glow%2C%20dramatic%20cinematic%20rim%20light%2C%20soft%20blurred%20background%2C%20editorial%20magazine%20texture%2C%20no%20people%2C%20high%20detail&width=900&height=600&seq=hl-feature-03&orientation=landscape',
  },
];

export const topicWall = [
  { name: '影视综艺', count: '342', hot: true },
  { name: '网红电商', count: '288', hot: true },
  { name: '电竞主播', count: '241', hot: false },
  { name: '时尚穿搭', count: '176', hot: false },
  { name: '情感吐槽', count: '214', hot: true },
  { name: '职场避雷', count: '158', hot: false },
  { name: '数码测评', count: '132', hot: false },
  { name: '音乐现场', count: '119', hot: false },
  { name: '影视评分', count: '187', hot: false },
  { name: '品牌翻车', count: '203', hot: true },
  { name: '饭圈日常', count: '265', hot: false },
  { name: '城市夜生活', count: '96', hot: false },
  { name: '美食探店', count: '84', hot: false },
  { name: '旅行见闻', count: '73', hot: false },
  { name: '宠物趣事', count: '61', hot: false },
  { name: '校园热议', count: '144', hot: false },
];

export const feedPosts = [
  {
    tag: '影视综艺',
    title: '未播片段流出引发猜想，剧方回应称系误读',
    excerpt: '评论区有人把两句台词前后拼接，得出完全相反的结论，话题热度一路走高。',
    comments: '4521',
    heat: '52.1万',
    time: '18 分钟前',
    image: 'https://readdy.ai/api/search-image?query=abstract%20vintage%20film%20camera%20and%20clapperboard%20on%20a%20dark%20reflective%20table%2C%20warm%20crimson%20and%20amber%20color%20grading%2C%20dramatic%20cinematic%20rim%20light%2C%20soft%20blurred%20background%2C%20editorial%20magazine%20texture%2C%20no%20people%2C%20high%20detail&width=800&height=560&seq=hl-feed-01&orientation=landscape',
  },
  {
    tag: '品牌翻车',
    title: '新品发布会文案被指抄袭，官方账号连夜修改',
    excerpt: '网友把两版文案截图并排对比，重复段落被逐句标出，讨论很快蔓延到话题墙。',
    comments: '3320',
    heat: '41.8万',
    time: '35 分钟前',
    image: 'https://readdy.ai/api/search-image?query=abstract%20conference%20microphone%20with%20blurred%20crowd%20bokeh%20in%20warm%20amber%20light%2C%20dark%20stage%20background%2C%20crimson%20accent%20glow%2C%20dramatic%20cinematic%20lighting%2C%20editorial%20magazine%20texture%2C%20no%20people%2C%20high%20detail&width=800&height=560&seq=hl-feed-02&orientation=landscape',
  },
  {
    tag: '情感吐槽',
    title: '一条聊天记录截图被转发上万次，评论区站成两队',
    excerpt: '有人觉得是沟通方式问题，也有人认为是原则问题，双方在话题墙各建了一个讨论帖。',
    comments: '5896',
    heat: '60.3万',
    time: '1 小时前',
    image: 'https://readdy.ai/api/search-image?query=abstract%20coffee%20cup%20and%20open%20notebook%20with%20handwritten%20notes%20on%20a%20dark%20wooden%20desk%20at%20night%2C%20warm%20crimson%20and%20amber%20color%20grading%2C%20soft%20blurred%20background%2C%20editorial%20magazine%20texture%2C%20no%20people%2C%20high%20detail&width=800&height=560&seq=hl-feed-03&orientation=landscape',
  },
  {
    tag: '电竞主播',
    title: '排位赛录像被逐帧分析，观众质疑操作异常',
    excerpt: '有人做了逐帧对比图，也有人认为是网络延迟导致，讨论区里技术流和吃瓜党各说各话。',
    comments: '4102',
    heat: '47.5万',
    time: '1 小时前',
    image: 'https://readdy.ai/api/search-image?query=abstract%20glowing%20computer%20monitor%20with%20blurred%20game%20interface%20in%20a%20dark%20room%2C%20warm%20amber%20and%20crimson%20light%20spill%2C%20dramatic%20cinematic%20rim%20light%2C%20soft%20blurred%20background%2C%20editorial%20texture%2C%20no%20people%2C%20high%20detail&width=800&height=560&seq=hl-feed-04&orientation=landscape',
  },
  {
    tag: '时尚穿搭',
    title: '红毯造型评分出炉，评论区审美大战再升级',
    excerpt: '同一套造型有人打满分有人打不及格，评分帖被顶到话题墙前列，吵得热闹。',
    comments: '2764',
    heat: '33.9万',
    time: '2 小时前',
    image: 'https://readdy.ai/api/search-image?query=abstract%20collage%20of%20glossy%20fashion%20magazine%20covers%20with%20warm%20crimson%20and%20gold%20light%20beams%2C%20layered%20paper%20texture%2C%20dramatic%20shadows%2C%20soft%20dark%20background%2C%20editorial%20premium%20feel%2C%20no%20people%2C%20high%20detail&width=800&height=560&seq=hl-feed-05&orientation=landscape',
  },
  {
    tag: '职场避雷',
    title: '面试问题合集被整理成表格，网友补充了几十条',
    excerpt: '表格从最开始的 20 条被补到近百条，评论区变成了大型互助现场，干货与吐槽齐飞。',
    comments: '3108',
    heat: '38.2万',
    time: '2 小时前',
    image: 'https://readdy.ai/api/search-image?query=abstract%20office%20desk%20with%20laptop%20notebooks%20and%20a%20cup%20of%20coffee%20at%20dusk%2C%20warm%20amber%20window%20light%2C%20crimson%20accent%20glow%2C%20soft%20blurred%20background%2C%20editorial%20magazine%20texture%2C%20no%20people%2C%20high%20detail&width=800&height=560&seq=hl-feed-06&orientation=landscape',
  },
  {
    tag: '音乐现场',
    title: '音乐节现场视频被指片段不完整，主办方暂未回应',
    excerpt: '同一首歌流传出三个不同机位的版本，观众各取一段拼出不同感受，讨论热度不减。',
    comments: '2210',
    heat: '29.7万',
    time: '3 小时前',
    image: 'https://readdy.ai/api/search-image?query=abstract%20spotlight%20beams%20crossing%20an%20empty%20concert%20stage%20with%20warm%20amber%20haze%2C%20crimson%20accent%20glow%2C%20dramatic%20cinematic%20lighting%2C%20soft%20blurred%20background%2C%20editorial%20magazine%20texture%2C%20no%20people%2C%20high%20detail&width=800&height=560&seq=hl-feed-07&orientation=landscape',
  },
  {
    tag: '美食探店',
    title: '排队三小时的网红店被吐槽，测评视频两种结论',
    excerpt: '一个视频说值得，一个视频说踩雷，网友干脆自己去排了一遍，回来直接开帖更新。',
    comments: '1893',
    heat: '25.4万',
    time: '4 小时前',
    image: 'https://readdy.ai/api/search-image?query=abstract%20warm%20cozy%20restaurant%20table%20with%20steaming%20dishes%20and%20soft%20candle%20light%20in%20a%20dark%20room%2C%20amber%20and%20crimson%20color%20grading%2C%20soft%20blurred%20background%2C%20editorial%20magazine%20texture%2C%20no%20people%2C%20high%20detail&width=800&height=560&seq=hl-feed-08&orientation=landscape',
  },
  {
    tag: '城市夜生活',
    title: '深夜街头随拍意外出圈，同款机位被网友排队打卡',
    excerpt: '一张雨后的霓虹街景被转发上万次，大家开始研究拍摄参数，顺便聊起了各自的城市。',
    comments: '1620',
    heat: '22.8万',
    time: '5 小时前',
    image: 'https://readdy.ai/api/search-image?query=abstract%20rainy%20urban%20alley%20with%20warm%20neon%20signage%20reflections%20on%20wet%20pavement%20at%20night%2C%20crimson%20and%20amber%20color%20grading%2C%20dramatic%20cinematic%20lighting%2C%20soft%20blurred%20background%2C%20editorial%20texture%2C%20no%20people%2C%20high%20detail&width=800&height=560&seq=hl-feed-09&orientation=landscape',
  },
  {
    tag: '饭圈日常',
    title: '应援物设计稿被提前泄露，粉丝群内部先吵了一轮',
    excerpt: '几个版本的设计稿在群里流转，审美意见难以统一，最后开了一个公开投票帖。',
    comments: '1422',
    heat: '19.6万',
    time: '6 小时前',
    image: 'https://readdy.ai/api/search-image?query=abstract%20colorful%20fan%20merchandise%20banners%20and%20glow%20sticks%20on%20a%20dark%20table%2C%20warm%20crimson%20and%20gold%20light%2C%20soft%20blurred%20background%2C%20editorial%20magazine%20texture%2C%20no%20people%2C%20high%20detail&width=800&height=560&seq=hl-feed-10&orientation=landscape',
  },
  {
    tag: '数码测评',
    title: '新机续航实测数据出炉，跑分与实际体验出现分歧',
    excerpt: '有人搬出实验室数据，有人坚持说日常体验才重要，两边在评论区凑齐了一整套论据。',
    comments: '1187',
    heat: '17.3万',
    time: '7 小时前',
    image: 'https://readdy.ai/api/search-image?query=abstract%20flat%20lay%20of%20modern%20gadgets%20and%20cables%20on%20a%20dark%20surface%20with%20warm%20amber%20light%2C%20crimson%20accent%20glow%2C%20soft%20blurred%20background%2C%20editorial%20magazine%20texture%2C%20no%20people%2C%20high%20detail&width=800&height=560&seq=hl-feed-11&orientation=landscape',
  },
  {
    tag: '校园热议',
    title: '毕业照创意被隔壁班“借鉴”，学生自发整理对比图',
    excerpt: '发布时间线被做成表格，评论区一边倒地讨论原创边界，话题墙也跟着热闹起来。',
    comments: '964',
    heat: '14.2万',
    time: '8 小时前',
    image: 'https://readdy.ai/api/search-image?query=abstract%20graduation%20caps%20and%20confetti%20on%20a%20dark%20table%20with%20warm%20golden%20light%2C%20crimson%20accent%20glow%2C%20soft%20blurred%20background%2C%20editorial%20magazine%20texture%2C%20no%20people%2C%20high%20detail&width=800&height=560&seq=hl-feed-12&orientation=landscape',
  },
];

export const hotRanking = [
  { rank: 1, title: '综艺剪辑争议时间线整理', heat: '98.6万', tag: '影视综艺' },
  { rank: 2, title: '直播带货成交曲线复盘', heat: '76.2万', tag: '网红电商' },
  { rank: 3, title: '直播间突发录屏分析', heat: '63.4万', tag: '电竞主播' },
  { rank: 4, title: '聊天记录截图转发上万', heat: '60.3万', tag: '情感吐槽' },
  { rank: 5, title: '新品发布会文案对比', heat: '41.8万', tag: '品牌翻车' },
  { rank: 6, title: '红毯造型审美大战', heat: '33.9万', tag: '时尚穿搭' },
];

export const communityComments = [
  {
    name: '路过的柠檬茶',
    time: '6 分钟前',
    text: '蹲了一下午，时间线终于有人整理清楚了，直接收藏慢慢看，这瓜是真的长。',
    likes: 328,
    badge: '话题贡献者',
  },
  {
    name: '夜宵摊观察员',
    time: '23 分钟前',
    text: '两边说的都有一点道理，但把完整证据摊开来看，其实结论没那么极端，理性吃瓜。',
    likes: 217,
    badge: '活跃讨论',
  },
  {
    name: '不熬夜星人',
    time: '41 分钟前',
    text: '本来只想扫一眼，结果从第一页翻到最后一页，黑料福利今日推荐是真的会挑话题。',
    likes: 194,
    badge: '每日打卡',
  },
  {
    name: '真相小分队',
    time: '1 小时前',
    text: '建议直接看话题墙置顶那张对比表，一张图胜过十篇小作文，省时间还不容易跑偏。',
    likes: 156,
    badge: '话题贡献者',
  },
];

export const trustPoints = [
  {
    icon: 'ri-refresh-line',
    title: '每日更新不断更',
    desc: '黑料福利每日固定整理当日热议话题，早晚各一次汇总，尽量不让你错过任何一条新料。',
  },
  {
    icon: 'ri-links-line',
    title: '只做话题聚合',
    desc: '站内内容以网友讨论与话题整理为主，标注来源与时间线，方便你自行判断而非被结论牵着走。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '社区守则明确',
    desc: '不发布未核实的个人信息，不引导攻击与网暴，违规内容会被折叠，讨论区求的是热闹更是干净。',
  },
  {
    icon: 'ri-group-line',
    title: '由社区共同维护',
    desc: '话题墙的排序与板块由大家的讨论热度决定，你点赞、转发、补充的每一条都会影响今日推荐。',
  },
];

export const faqs = [
  {
    q: '黑料福利是每天都会更新吗？',
    a: '是的。黑料福利每日更新，通常在上午与晚间各做一次内容汇总，热门话题还会当天追加更新，尽量保证不断更。',
  },
  {
    q: '在哪里能看到黑料福利今日的最新新料？',
    a: '首页顶部的更新条会实时播报当日上新的条目，往下滚动到「今日最新新料」聚合区，即可按时间顺序查看今日全部更新。',
  },
  {
    q: '话题墙是怎么排出来的？',
    a: '话题墙按社区近 24 小时的讨论热度动态排序，参与讨论、点赞、补充信息都会影响位置，越多人聊的话题越靠前。',
  },
  {
    q: '内容可以自己发布或补充吗？',
    a: '目前首页为静态展示，展示的是话题整理与讨论氛围。后续会开放话题补充入口，届时你可以直接为感兴趣的话题追加线索与时间线。',
  },
  {
    q: '为什么有些讨论会被折叠？',
    a: '涉及未核实的个人信息、人身攻击或明显引战的发言，会被折叠处理。我们希望讨论是热闹的，但对象是话题本身而不是具体的人。',
  },
  {
    q: '黑料福利会收费吗？',
    a: '日常浏览、查看今日更新与参与话题讨论都免费。首页所有按钮目前保持展示状态，等到正式开放入口时会在这里第一时间说明。',
  },
];

export const footerLinks = [
  {
    title: '今日内容',
    links: [
      { label: '今日最新新料', href: '#latest' },
      { label: '每日更新播报', href: '#update' },
      { label: '本周热门话题', href: '#topics' },
    ],
  },
  {
    title: '社区',
    links: [
      { label: '话题墙', href: '#topics' },
      { label: '讨论氛围区', href: '#community' },
      { label: '社区守则', href: '#trust' },
    ],
  },
  {
    title: '帮助',
    links: [
      { label: '常见问题', href: '#faq' },
      { label: '内容说明', href: '#trust' },
      { label: '返回顶部', href: '#top' },
    ],
  },
];